<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre questxt">{{question}}</h1>
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_q1}}</h1>
  <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
    <label class="custom-control custom-checkbox chkbox mb-2" for="device1">
      <input type="checkbox" class="custom-control-input mgntp10" id="device1" value="hgHomedevices.device1" name="smartDevice" [disabled] = "disable"
        [(ngModel)]="hgHomedevices.device1" (ngModelChange)="getDevices('Smart thermostat (Nest, Ecobee, etc)', hgHomedevices.device1)" />
      <label class="custom-control-label font20" for="device1">Smart thermostat (Nest, Ecobee, etc)</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device2">
      <input type="checkbox" class="custom-control-input mgntp10" id="device2" value="hgHomedevices.device2" [disabled] = "disable"
        name="smartDevice" [(ngModel)]="hgHomedevices.device2" (ngModelChange)="getDevices('Virtual assistant (Alexa, Siri, Google, etc)', hgHomedevices.device2)" />
      <label class="custom-control-label font20" for="device2">Virtual assistant (Alexa, Siri, Google, etc)</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device3">
      <input type="checkbox" class="custom-control-input mgntp10" id="device3" value="hgHomedevices.device3" [disabled] = "disable"
        name="smartDevice" [(ngModel)]="hgHomedevices.device3" (ngModelChange)="getDevices('Smart outlets', hgHomedevices.device3)" />
      <label class="custom-control-label font20" for="device3">Smart outlets</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device4">
      <input type="checkbox" class="custom-control-input mgntp10" id="device4" value="hgHomedevices.device4" name="smartDevice" [disabled] = "disable"
        [(ngModel)]="hgHomedevices.device4" (ngModelChange)="getDevices('Smart lightbulbs', hgHomedevices.device4)" />
      <label class="custom-control-label font20" for="device4">Smart lightbulbs</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device5">
      <input type="checkbox" class="custom-control-input mgntp10" id="device5" value="hgHomedevices.device5" [disabled] = "disable"
        name="smartDevice" name="smartDevice" [(ngModel)]="hgHomedevices.device5" (ngModelChange)="getDevices('Smart light switches', hgHomedevices.device5)" />
      <label class="custom-control-label font20" for="device5">Smart light switches</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device6">
      <input type="checkbox" class="custom-control-input mgntp10" id="device6" value="hgHomedevices.device6"
        name="smartDevice" name="smartDevice" [(ngModel)]="hgHomedevices.device6" (ngModelChange)="getDevices('None of the above', hgHomedevices.device6)" />
      <label class="custom-control-label font20" for="device6">None of the above</label>
    </label>
  </div>
  <p class="m-0 mb-2 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
  <button class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
  <!-- <p class="text-success mt-3" *ngIf="showTip">{{questionObj.tip}}</p> -->
  <!--enhancement-->
  <!-- <div *ngIf="showTip">
    <div class="mt-5">
      <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center font-weight-bold">TIP OF THE DAY<br>
          <a class="font-weight-normal">{{questionObj.tip}}</a></p>
      </div>
    </div>
  </div> -->
</div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
          <div class="arrow_box" >
              <h1 class="questionMob text-left">{{question}}</h1>
          </div>
      </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <label class="custom-control custom-checkbox chkbox mb-2" for="device1_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="device1_mob" value="hgHomedevices.device1" name="smartDevice" [disabled] = "disable"
        [(ngModel)]="hgHomedevices.device1" (ngModelChange)="getDevices('Smart thermostat (Nest, Ecobee, etc)', hgHomedevices.device1)" />
      <label class="custom-control-label font20" for="device1_mob">Smart thermostat (Nest, Ecobee, etc)</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2"for="device2_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="device2_mob" value="hgHomedevices.device2" [disabled] = "disable"
        name="smartDevice" [(ngModel)]="hgHomedevices.device2" (ngModelChange)="getDevices('Virtual assistant (Alexa, Siri, Google, etc)', hgHomedevices.device2)" />
      <label class="custom-control-label font20" for="device2_mob">Virtual assistant (Alexa, Siri, Google, etc)</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device3_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="device3_mob" value="hgHomedevices.device3" [disabled] = "disable"
        name="smartDevice" [(ngModel)]="hgHomedevices.device3" (ngModelChange)="getDevices('Smart outlets', hgHomedevices.device3)" />
      <label class="custom-control-label font20" for="device3_mob">Smart outlets</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device4_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="device4_mob" value="hgHomedevices.device4" name="smartDevice" [disabled] = "disable"
        [(ngModel)]="hgHomedevices.device4" (ngModelChange)="getDevices('Smart lightbulbs', hgHomedevices.device4)" />
      <label class="custom-control-label font20" for="device4_mob">Smart lightbulbs</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device5_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="device5_mob" value="hgHomedevices.device5" [disabled] = "disable"
        name="smartDevice" name="smartDevice" [(ngModel)]="hgHomedevices.device5" (ngModelChange)="getDevices('Smart light switches', hgHomedevices.device5)" />
      <label class="custom-control-label font20" for="device5_mob">Smart light switches</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="device6_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="device6_mob" value="hgHomedevices.device6" 
        name="smartDevice" name="smartDevice" [(ngModel)]="hgHomedevices.device6" (ngModelChange)="getDevices('None of the above', hgHomedevices.device6)" />
      <label class="custom-control-label font20" for="device6_mob">None of the above</label>
    </label>
    <p class="m-auto mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <br />
    <!-- <div class="col-sm-10 text-left" *ngIf="showTyping">
      <img src="assets/images/typing-animated-gif-1.gif"/>
    </div> -->
    <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/signimg.jpg" />
      </div>
      <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
         <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
      </div>
    </div>
    <!--enhancement-->
    <!-- <div *ngIf="showTip">
      <div>
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
          <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
          <p class="text-center font-weight-bold">TIP OF THE DAY<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p>
        </div>
      </div>
    </div> -->
  </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active21.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active15.png"></span>
    <h5 class="clr333 processtxt">75% Completed</h5>
  </div>
</div> -->